/** Prefixes for room names; room formats are prefix, a dash, and an id */
export var RoomPrefix;
(function (RoomPrefix) {
    RoomPrefix["Backtest"] = "backtests";
    RoomPrefix["Account"] = "accounts";
    RoomPrefix["workspace"] = "workspace";
})(RoomPrefix || (RoomPrefix = {}));
/** Commands from the client to the server */
export var SocketCommands;
(function (SocketCommands) {
    SocketCommands["create"] = "create";
    SocketCommands["joinWorkspace"] = "join-workspace";
    SocketCommands["leaveWorkspace"] = "leave-workspace";
    SocketCommands["status"] = "status";
    SocketCommands["closeRoom"] = "closeRoom";
})(SocketCommands || (SocketCommands = {}));
/** Events from the server to the client */
export var SocketEvents;
(function (SocketEvents) {
    SocketEvents["activeApp"] = "active-app::claim";
    SocketEvents["checkAppVersion"] = "check-app-version";
    SocketEvents["LocateOrder"] = "locate-order";
    SocketEvents["WorkspaceUpdated"] = "workspace-update";
    SocketEvents["BacktestStatus"] = "backtest-status";
})(SocketEvents || (SocketEvents = {}));
/** Base interface for client to server messages */
// export interface ClientMessage {}
/** Base interface for server to client messages */
// export interface PushMessage {}
//# sourceMappingURL=push.js.map